module.exports = __webpack_public_path__ + "img/profile-dark.0cd73f7e.jpg";